"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPromoTokensSortToJSON = exports.GetPromoTokensSortFromJSONTyped = exports.GetPromoTokensSortFromJSON = exports.GetPromoTokensSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetPromoTokensSort;
(function (GetPromoTokensSort) {
    GetPromoTokensSort["CreatedAt"] = "createdAt";
})(GetPromoTokensSort = exports.GetPromoTokensSort || (exports.GetPromoTokensSort = {}));
function GetPromoTokensSortFromJSON(json) {
    return GetPromoTokensSortFromJSONTyped(json, false);
}
exports.GetPromoTokensSortFromJSON = GetPromoTokensSortFromJSON;
function GetPromoTokensSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetPromoTokensSortFromJSONTyped = GetPromoTokensSortFromJSONTyped;
function GetPromoTokensSortToJSON(value) {
    return value;
}
exports.GetPromoTokensSortToJSON = GetPromoTokensSortToJSON;
